import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { logController } from "../../controllers/log.controller";
import { dateConvert } from "../common/Helpers";
import LoadingPanel from "../common/LoadingPanel";
import LogReportGrid from "./LogReport/LogReportGrid";
import LogReportDetail from "./LogReport/LogReportDetail";
import DialogWindow from "../common/DialogWindow";

class Log extends Component {
    state = {
        loading: true,
        logs: null
    };

    constructor(props) {
        super(props);
        this.typingTimeout = null;
    }

    componentDidMount() {
        this.getLogs();
    }

    refreshGrid = () => {
        this.getLogs(this.state.filter);
    };

    getLogs(filter) {
        this.setState({
            loading: true
        });
        logController.getLogsByUzivatelOrSklad(filter).then((ajaxData) => {
            let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
            this.setState({
                logs: data,
                loading: false
            });
        });
    }

    callSearch = (filter) => {
        this.setState({
            filter: filter
        });
        var getLogsCallback = () => {
            this.getLogs(filter);
        };
        // Clears the previously set timer.
        clearTimeout(this.typingTimeout);
        // Reset the timer, to make the http call after 475MS (this.callSearch is a method which will call the search API. Don't forget to bind it in constructor.)
        this.typingTimeout = setTimeout(getLogsCallback, 800);
    };

    openLogDetailDialog = (log) => {
        this.setState({
            dialog: {
                title: "Detail logu č. " + log.id,
                content: () => LogReportDetail(log),
                height: "90%",
                width: "90%"
            }
        });
    };

    render() {
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : (
            <div>
                <LogReportGrid
                    items={this.state.logs}
                    refreshGrid={this.refreshGrid}
                    callSearch={this.callSearch}
                    filter={this.state.filter}
                    openLogDetail={this.openLogDetailDialog}
                />
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );

        return <div className="wrapper wrapper-content">{contents}</div>;
    }
}

export default withRouter(Log);



// WEBPACK FOOTER //
// ./src/components/views/Log.js